"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhonenumberDidTypeEnum = void 0;
var PhonenumberDidTypeEnum;
(function (PhonenumberDidTypeEnum) {
    PhonenumberDidTypeEnum["FIXED_LINE"] = "FIXED_LINE";
    PhonenumberDidTypeEnum["MOBILE"] = "MOBILE";
    PhonenumberDidTypeEnum["SHARED_COST"] = "SHARED_COST";
    PhonenumberDidTypeEnum["TOLL_FREE"] = "TOLL_FREE";
})(PhonenumberDidTypeEnum = exports.PhonenumberDidTypeEnum || (exports.PhonenumberDidTypeEnum = {}));
